import React from "react";
import CategoryData from "./CategoryData/CategoryData";
import {ScrollPanel} from 'primereact/scrollpanel';
import classes from './CategoriesData.module.css'

const CategoriesData = (props) => {
    return (
        <ScrollPanel className={classes.scroll} style={{width: '100%'}}>
            {props.categoriesProps.map((e, i) => (
                <div className="mb-3" key={`cat-${i + 1}`}>
                    <CategoryData
                        marketNode={e['marketNodeDTO']}
                        dcMarketNodeId={props.dcMarketNodeId}
                        category={e}
                        index={i}
                        haveMultipleCategories={props.categoriesProps.length > 1}
                        modelPath={props.modelPath}
                        statusLV4={props.statusLV4}
                        crossValidationMsg={props.crossValidationMsg}
                        shouldLockUpload={props.shouldLockUpload}
                        dataCollection={props.dataCollection}
                        setValidationButtonDisabled={props.setValidationButtonDisabled}
                        categoriesProps={props.categoriesProps}
                        findByDCAndMN={props.findByDCAndMN}
                        marketNodeDataIsPublishing={props.marketNodeDataIsPublishing}
                        setBtnPublishVisibility={props.setBtnPublishVisibility}
                        uploadMethod={e['categoryDTO'].uploadMethod === null ? "xlsx-ttl" : e['categoryDTO'].uploadMethod.name}
                        onDataReuploaded={props.onDataReuploaded}
                    />
                </div>
            ))}
        </ScrollPanel>
    )
}

export default CategoriesData;
